
import React from 'react';
import { Language } from '../../types';
import { TRANSLATIONS } from '../../constants';

type TabType = 'profile' | 'app' | 'security';

interface SettingsTabsProps {
  language: Language;
  activeTab: TabType;
  setActiveTab: (tab: TabType) => void;
}

const SettingsTabs: React.FC<SettingsTabsProps> = ({ language, activeTab, setActiveTab }) => {
  const t = TRANSLATIONS[language];
  return (
    <div className="px-6 pt-4 shrink-0">
      <div className="flex bg-slate-100 dark:bg-white/5 p-1 rounded-xl border border-slate-200/50 dark:border-white/5">
        {(['app', 'profile', 'security'] as const).map((tab) => (
          <button 
            key={tab}
            onClick={() => setActiveTab(tab)}
            className={`flex-1 py-2 text-[10px] font-black rounded-lg transition-all flex items-center justify-center gap-2 uppercase tracking-wide
              ${activeTab === tab 
                ? 'bg-white dark:bg-emerald-500 text-emerald-600 dark:text-white shadow-sm' 
                : 'text-slate-400 hover:text-slate-600 dark:hover:text-slate-300'}
            `}
          >
            <i className={`fas ${tab === 'app' ? 'fa-sliders' : tab === 'profile' ? 'fa-user' : 'fa-shield-halved'}`}></i>
            {tab === 'app' ? t.appPrefs : tab === 'profile' ? t.profile : t.security}
          </button>
        ))}
      </div>
    </div>
  );
};
export default SettingsTabs;
